/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Rooster_Pauze_VerwijderenInputs */

const nl_planning_rooster_pauze_verwijderen = /** @type {(inputs: Planning_Rooster_Pauze_VerwijderenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pauze verwijderen`)
};

/**

* @param {Planning_Rooster_Pauze_VerwijderenInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_rooster_pauze_verwijderen = /** @type {((inputs?: Planning_Rooster_Pauze_VerwijderenInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Rooster_Pauze_VerwijderenInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_rooster_pauze_verwijderen(inputs)
});
export { planning_rooster_pauze_verwijderen as "planning.rooster.pauze_verwijderen" }